import React from 'react'
import { Map, Marker, GoogleApiWrapper } from 'google-maps-react';


   
const GoogleMap = () => {
    return (
        <div>
            
        </div>
    )
}

export default GoogleMap
